// Contrato dos tokens semânticos (theme.custom). Todo tema passa por aqui:
// campos ausentes ganham defaults derivados da palette — os 4 temas básicos
// migrados continuam visualmente idênticos sem declarar custom completo.
export const normalizeCustom = (cfg = {}) => {
  const p = cfg.palette || {};
  const textPrimary = p.text?.primary || "#0F172A";
  const c = cfg.custom || {};
  const chat = c.chat || {};
  const sentBg = chat.sentBg || "#FFF3E8";
  return {
    chat: {
      sentBg,
      sentText: chat.sentText || textPrimary,
      receivedBg: chat.receivedBg || p.background?.paper || "#FFFFFF",
      receivedText: chat.receivedText || textPrimary,
      quotedSentBg: chat.quotedSentBg || sentBg,
      quotedReceivedBg: chat.quotedReceivedBg || "#F0F0F0",
      accent: chat.accent || p.primary?.main || "#F37021",
      // Barra da citação recebida + nome do contato em grupos. Default é o
      // ciano histórico (#6bcbef) para manter os temas básicos pixel-idênticos;
      // temas novos declaram o seu (distinto do accent de "enviada").
      contactAccent: chat.contactAccent || "#6bcbef",
    },
    chartPalette:
      c.chartPalette && c.chartPalette.length >= 6
        ? c.chartPalette
        : [p.primary?.main || "#F37021", "#0071BC", "#273A74", "#4CAF50", "#E74C3C", "#8B5CF6"],
    login: { bg: c.login?.bg || "#555A5F" },
    decorId: c.decorId || null,
    headingFont: c.headingFont || null,
  };
};
